import { createSlice } from '@reduxjs/toolkit';

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    createJobSuccessful: false,
    createJobError: null,
    pendingJobs: [],
    updateJobError: null,
    completedJobs: [],
    pendingJobOffers: [],
    confirmedJobs: [],
    activeJobs: [],
  },
  reducers: {
    setCreateJobError: (state, action) => {
      state.createJobError = action.payload;
    },
    setCreateJobSuccess: (state, action) => {
      state.createJobSuccessful = action.payload;
    },
    setPendingJobs: (state, action) => {
      state.pendingJobs = action.payload;
    },
    setUpdateJobError: (state, action) => {
      state.updateJobError = action.payload;
    },
    setCompletedJobs: (state, action) => {
      state.completedJobs = action.payload;
    },
    setPendingJobOffers: (state, action) => {
      state.pendingJobOffers = action.payload;
    },
    setConfirmedJobs: (state, action) => {
      state.confirmedJobs = action.payload;
    },
    setActiveJobs: (state, action) => {
      state.activeJobs = action.payload;
    },
  },
});

export const {
  setCreateJobError,
  setCreateJobSuccess,
  setPendingJobs,
  setUpdateJobError,
  setCompletedJobs,
  setPendingJobOffers,
  setConfirmedJobs,
  setActiveJobs,
} = jobsSlice.actions;

export default jobsSlice.reducer;
